// 画像ソートプレビュー
const ImageSort = {
  namespaced: true,

  state: {
    sort: false,
    image: {
      label: '',
      caption: '',
      panoramaCategory: null,
      image: '',
      category: null,
      type: '',
      number: null,
      m: '',
      nearMasterId: null,
      id: null,
    },
  },
  getters: {
    getSort: state => {
      return state.sort
    },
    getImage: state => {
      return state.image
    },
  },
  mutations: {
    setSort(state, sort) {
      state.sort = sort
    },
    setImage(state, image) {
      state.image = image
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setImage', item)
      commit('setSort', true)
    },
    reset({ commit }) {
      const image = {
        label: '',
        caption: '',
        panoramaCategory: null,
        image: '',
        category: null,
        type: '',
        number: null,
        m: '',
        nearMasterId: null,
        id: null,
      }
      commit('setSort', false)
      setTimeout(
        function () {
          commit('setImage', image)
        }.bind(),
        300,
      )
    },
  },
}

export default ImageSort
